module.exports = __webpack_public_path__ + "img/lend.77a34655.svg";